import type { MembroListaElettorale } from '@framework/api-client';
import { Datatype } from '@framework/engine';
import { FilterInputType } from '@framework/ui';

export interface ICandidateColumn {
  type: Datatype;
  name: keyof MembroListaElettorale;
  label: string;
  filterType?: FilterInputType;
  sorter?: boolean;
}

/**
 * Colonne per la visualizzazione dei membri della lista elettorale.
 */
export const CandidateColumns: ICandidateColumn[] = [
  {
    type: Datatype.String,
    name: 'id',
    label: 'ID Membro',
    filterType: FilterInputType.Text,
  },
  {
    type: Datatype.Number,
    name: 'ordine',
    label: 'Ordine',
    filterType: FilterInputType.Number,
  },
  {
    type: Datatype.String,
    name: 'nome',
    label: 'Nome',
    filterType: FilterInputType.Text,
    sorter: true,
  },
  {
    type: Datatype.String,
    name: 'cognome',
    label: 'Cognome',
    filterType: FilterInputType.Text,
    sorter: true,
  },
  {
    type: Datatype.Date,
    name: 'dataNascita',
    label: 'Data di nascita',
    filterType: FilterInputType.DateRange,
  },
  {
    type: Datatype.String,
    name: 'profilo',
    label: 'Profilo',
    filterType: FilterInputType.Text,
  },
  {
    type: Datatype.String,
    name: 'codiceFiscale',
    label: 'Codice fiscale',
    filterType: FilterInputType.Text,
  },
  {
    type: Datatype.Boolean,
    name: 'isCandidato',
    label: 'Candidato',
    sorter: true,
  },
];

/**
 * Colonne membro corrispondenti ai nomi configurati (sottoinsieme di
 * `CandidateColumns`). Condivisa fra il widget candidato (CTS) e il widget di
 * scelta lista (CS), che mostrano gli stessi campi membro.
 */
export function getCandidateColumns(
  columnNames: string[] | undefined,
): ICandidateColumn[] {
  return CandidateColumns.filter(c => columnNames?.includes(c.name));
}
